import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const deleteReportFileReq = (requestId: string, transactionType: string, mid: string, tokens: any, isSmid: boolean) => {
  const request: Request<{}> = {
    apiPath:
      transactionType !== 'SETTLEMENT' ? APIEndPoints.deleteTxnsRefundsReport : APIEndPoints.deleteSettlementsReport,
    method: 'POST',
    config: sitConfig(tokens),
    // headers: {
    //   'Content-Type': 'application/json',
    //   Authorization: userAccessToken,
    // },
    body: {
      inputFilter: {
        transactionType: transactionType,
        merchantId: mid,
        requestId: requestId,
        isSMID: isSmid ? 'Y' : 'N',
      },
      configParams: {},
      outputDomains: [],
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { deleteReportFileReq }
